import { isWeb } from "../utils/utils";
import api_comm from "./lib";

async function submitClaim(
	claim,
	session_token,
	identity_no,
	storemember_guid
) {
	// let isPDF = claim.attachment_proof_of_sale?.uri?.includes("pdf");
	// console.log("isPDF => ", isPDF);

	let base64 = claim.attachment_proof_of_sale?.uri?.split(",")[1];

	let File = isWeb() ? base64 : claim.attachment_proof_of_sale?.uri;

	let product_identifier = claim.device_serial?.split("\n");

	let params = {
		account_details: {
			id_passport: identity_no,
		},
		claim: {
			transaction_date: claim.transaction_date,
			store_guid: claim.store_guid,
			storemember_guid: storemember_guid,
			product_identifier: product_identifier,
		},
		attachment: {
			attachment_proof_of_sale: File,
		},
	};

	return api_comm("post", "/claims/api/v2/claim", params, session_token);
}

export default submitClaim;
